import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Card, Col, Row, Button } from "react-bootstrap";

import EagleEyeLiveView from "components/Common/Cameras/CameraList/EagleEyeLiveView";

import Icon from "components/Icons/Icon";
import { Tooltip } from "components/Common/Tooltip/";
import Loading from "components/Loading"

import { withT } from "services/translation/";

import { requestRemoveSiteCameraStart } from "services/redux/actions";

import "./EagleEyeScss.scss";

import {
    getCurrentSite,
    getSites,
    getSiteById
} from "services/redux/selectors/sites";

import SelectBundle from "../SelectBundle";

import Alert from "components/Common/Alert";

import AuthorisationModal from "components/Common/Cameras/AuthorisationModal";

function CameraCard({
    integration,
    site,
    removeCamera,
    auth_token,
    site_id,
    site_name,
    loading,
    integration_id,
    account_id,
    subdomain,
    auth_expired,
    t }) {

    const [showEagleEyeState, setShowEagleEyeState] = useState(false);
    const [showModal, setShowState] = useState({show: false});

    function removeCameraHelper() {
        Alert({
            title: t("remove_camera_confirm", site.camera_name),
            icon: "warning",

            showCancelButton: true
        }).then(result => {
            if (result.value) {
                removeCamera({
                    camera_sudo_site_id: site_id,
                    site_id,
                    integration_id,
                    body: {
                        active: false
                    }
                });
            }
        });
    }

    let showModalFunction = () => {
        setShowState({show: true})
    }

    let hideModal = () => {
        setShowState({show: false})
    }

    let integration_type='eagle_eye';
    let integration_type_string='Eagle Eye';

    const expiredToolTip = (
        <>
        <Tooltip
            title="Authorisation Expired"
            description="Click Here to Reauthorise"
            placement="bottom"
        >
            <Button
                variant="danger"
                data-testid="live-view-button"
                size="sm"
                style={{ 'marginRight': '5px' }}
                onClick={showModalFunction}
            >
                <Icon className="fas fa-video" />
            </Button>
        </Tooltip>
        {showModal && 
                    <AuthorisationModal 
                        show={showModal.show}
                        hideModal={hideModal}
                        properties={integration}
                        integration_type={integration_type}
                        integration_type_string={integration_type_string}
                    />
                    }
        </>
    );

    return (
        <Col md="12">
            <Card className="border-dark bg-light">
                <Card.Body>
                    <Row>
                        <Col>
                            <div
                                className="float-left font-16 pr-2"
                            >
                                {auth_expired ? (expiredToolTip) :
                                    <>
                                        <Button
                                            variant="outline-primary"
                                            data-testid="live-view-button"
                                            size="sm"
                                            style={{ 'marginRight': '5px' }}
                                            // onClick={() => (setShowEagleEyeState(true))}
                                            onMouseEnter={() => (setShowEagleEyeState(true))}
                                            onMouseLeave={() => (setShowEagleEyeState(false))}
                                        >
                                            <Icon className="fas fa-video" />
                                        </Button>
                                    </>
                                }
                                {site.camera_name}
                            </div>
                            <div className="float-right">
                                {loading ? (
                                    <Loading center />
                                ) : (
                                    <Tooltip
                                        placement="left"
                                        description={t("remove_camera_tooltip")}>
                                        <Button
                                            disabled={loading}
                                            onClick={removeCameraHelper}
                                            size="sm"
                                            variant="danger"
                                            className="px-2">
                                            <Icon className="fas fa-times" />
                                        </Button>
                                    </Tooltip>
                                )}
                            </div>
                        </Col>
                    </Row>

                    {showEagleEyeState &&
                        <>
                            <div className="eagle-eye-live-view">
                                <EagleEyeLiveView
                                    camera_ref={site.camera_ref}
                                    auth_token={auth_token}
                                    account_id={account_id}
                                    subdomain={subdomain}
                                    src="buttonview"
                                    auth_expired={auth_expired} />
                                {" "}
                            </div>
                        </>
                    }

                    <hr />
                    <Row>
                        <Col>
                            <SelectBundle
                                currentBundleIds={site.conxtd_alarm_bundles.map(({ id }) => id)}
                                camera_ref={site.camera_ref}
                                camera_name={site.camera_name}
                                camera_integration_site_id={site.camera_integration_site_id}
                                camera_sudo_site_id={site.id}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    );
}
CameraCard.propTypes = {
    /**
     * @param removeCamera api dispatch to remove camera from site
     */
    removeCamera: PropTypes.func.isRequired,

    /**
     * @param loading api loading status (null|true|false)
     */
    loding: PropTypes.any,

    /**
     * @param site_id id site to use for api integrations refresh
     */
    site_id: PropTypes.any.isRequired,

    /**
     * @param integration_id id of the integration
     */
    integration_id: PropTypes.number.isRequired,
};

const mapStateToProps = (state, props) => {
    const site_id = parseInt(getCurrentSite(state, props).id);
    const site = getSiteById(getSites(state, props), site_id);

    return {
        loading: state.sites.current.integrations.cameras.actions.remove.loading,
        site_id,
        site_name: site.name
    };
};
const mapDispatchToProps = {
    removeCamera: requestRemoveSiteCameraStart
};

export default withT(
    connect(mapStateToProps, mapDispatchToProps)(CameraCard),
    "site_overview.side_pane.manage_integrations.providers.eagle_eye"
);